module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"account_create":"Create an account","access":"Access to {to}","subscribe":"Register to access to","already_account":"I already have an account"},"fr":{"account_create":"Créer un compte","access":"Accéder à {to}","subscribe":"Inscrivez-vous pour accéder à","already_account":"J\u0027ai déjà un compte"}}')
  delete Component.options._Ctor
}
